
import { Module } from '@/data/courses/types';
import { QuizContent } from '@/types/quizTypes';

// Normalize quiz content from any module type to a consistent format
export const normalizeQuizContent = (module: Module): QuizContent | null => {
  // Try to get quiz content from quiz property first
  if (module.quiz && module.quiz.questions && module.quiz.questions.length > 0) {
    return {
      questions: module.quiz.questions.map(q => ({
        id: q.id,
        question: q.question,
        options: q.options,
        correctAnswer: q.correctAnswer,
        correctAnswerIndex: q.correctAnswerIndex || q.correctAnswer,
        difficulty: q.difficulty || 'medium',
        explanation: q.explanation,
        category: q.category || 'general',
        points: q.points || 15,
        type: q.type || 'multiple-choice'
      })),
      passThreshold: module.quiz.passThreshold || 75,
      timeLimit: module.quiz.timeLimit || 600,
      category: module.quiz.category || 'general'
    };
  }

  // Fall back to quickCheck if no quiz
  if (module.quickCheck && module.quickCheck.questions && module.quickCheck.questions.length > 0) {
    return {
      questions: module.quickCheck.questions.map(q => ({
        id: q.id,
        question: q.question,
        options: q.options,
        correctAnswer: q.correctAnswer,
        correctAnswerIndex: q.correctAnswerIndex || q.correctAnswer,
        difficulty: q.difficulty || 'medium',
        explanation: q.explanation,
        category: 'general',
        points: 15,
        type: 'multiple-choice'
      })),
      passThreshold: module.quickCheck.passThreshold || 75,
      timeLimit: 600,
      category: 'general'
    };
  }

  return null;
};
